module.exports = __webpack_public_path__ + "static/media/content-1.14479c03.png";